// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";

function InjectableRichText(props) {
  var injectArr = props.injectArr;
  var match = React.useState(function () {
        return false;
      });
  var setIsBrowser = match[1];
  var isBrowser = match[0];
  var container = React.useRef(null);
  React.useEffect((function () {
          Curry._1(setIsBrowser, (function (param) {
                  return true;
                }));
        }), []);
  React.useEffect((function () {
          if (isBrowser) {
            var dom = container.current;
            if (!(dom == null)) {
              Belt_Array.forEach(Belt_Option.getWithDefault(injectArr, []), (function (tpl) {
                      var injectEl = dom.querySelector(tpl[0]);
                      if (injectEl !== null) {
                        ReactDom.render(tpl[1], injectEl);
                        return ;
                      }
                      
                    }));
            }
            
          }
          
        }), [isBrowser]);
  if (isBrowser) {
    return JsxRuntime.jsx("div", {
                ref: Caml_option.some(container),
                dangerouslySetInnerHTML: {
                  __html: props.children
                }
              });
  } else {
    return null;
  }
}

var make = InjectableRichText;

export {
  make ,
}
/* react Not a pure module */
